import { useGebruikerContext } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { debounce } from "../../helpers";
import { Button, Modal, ModalBody } from "reactstrap";
import { useParams } from "react-router";
import { useMemo } from "react";
import { useUpdateGebruikerDetail } from "Api/Coordinator/Gebruikers/Algemeen";
import moment from "moment";

export const AlgemeenContext = createContext();

export const useAlgemeenContext = () => {
	const context = useContext(AlgemeenContext);
	if (!context) throw new Error("Use algemeen context within provider.");
	return context;
};

export const AlgemeenProvider = ({ children }) => {
	const { userDetails: data, currentUser, fetchUserDetails, disable } = useGebruikerContext();
	const [errorField, setErrorField] = useState({});
	const [showDisableModal, setShowDisableModal] = useState(false);
	const { trigger: updateGebruikerDetail } = useUpdateGebruikerDetail();
	const params = useParams();
	const Id = params.gebruikerId || '';

	useEffect(() => {
		if (disable) {

			setShowDisableModal(true);
		}
	}, [disable]);

	const callApi = (fieldOrValues, value, setModal) => {
		const adminId = currentUser?.data?.clooserId || Id;

		let attr;

		if (typeof fieldOrValues === "string") {
			// Single field update (username)
			attr = {
				[fieldOrValues]: value,
			};
		} else {
			// Multiple fields update (Opslaan button)
			attr = { ...fieldOrValues };

			if (attr.dBirthdate) {
				attr.dBirthdate = moment(attr.dBirthdate).format("DD-MM-YYYY");
			}
		}
		const bodyData = {
			iAdminId: adminId,
			attr,
		};
	
		updateGebruikerDetail({ data: bodyData })
			.then((response) => {
				if (response?.status || response?.success) {
					setErrorField({});
					fetchUserDetails();
					setModal && setModal(false);
					return;
				}

				const errorData = response?.data || {};

				setErrorField(errorData);


				Object.values(errorData).forEach((errors) => {
					if (Array.isArray(errors)) {
						toast.error(errors.join(", "));
					} else if (errors) {
						toast.error(errors);
					}
				});

			})
			.catch((error) => {
				console.error(error);
			});
	};

	const debouncedApiCall = useMemo(() => debounce(callApi, 2000), [data, currentUser]);

	const handleFieldChange = (field, value, setModal = null) => {

		setErrorField();
		if (setModal) {
			callApi(field, value, setModal);
			return;
		}
		debouncedApiCall(field, value);
	};

	const handleSave = (values) => {
		setErrorField({});
		callApi(values);
	};

	return (
		<AlgemeenContext.Provider
			value={{
				errorField,
				setErrorField,
				handleFieldChange,
				handleSave
			}}
		>
			{children}
			{showDisableModal && (
				<Modal
					isOpen={showDisableModal}
					toggle={() => setShowDisableModal(false)}
					className="feedback-modal-style role-modal modal-centered"
				>
					<ModalBody>
						<p className="mt-5 text-center text-red">
							U bent niet gemachtigd om gegevens van een gebruiker te wijzigen met de rol coordinator
						</p>

						<div className="d-flex align-items-center justify-content-center border-bottom-0 gap-4 py-4">
							<Button
								className="btn-color-style opslaan-btn px-4"
								size="lg"
								outline
								color="primary"
								onClick={() => setShowDisableModal(false)}
							>
								OK
							</Button>
						</div>
					</ModalBody>
				</Modal>
			)}
		</AlgemeenContext.Provider>
	);
};
